import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';

export default class DeliveryInstructionFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.diNumber = '';
		this.deliveryOrderId  = '';
		this.deliveryOrderDoNumber = '';
		this.poNoCustomer = '';
		this.diDeliveryDateFrom = '';
		this.diDeliveryDateTo = '';
		this.diCreateDateFrom = '';
		this.diCreateDateTo = '';
		this.diStatusId  = '';
		this.diStatusCode = '';
		this.diStatusName = '';
		this.diCustomerId  = '';
		this.diCustomerCode = '';
		this.partDestinationId  = '';
		this.partDestinationDestination = '';
		this.destinationId  = '';
		this.destinationCode = '';
		this.officeAddress = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			diNumber : '0',
			deliveryOrderId : '0',
			deliveryOrderDoNumber : '0',
			poNoCustomer : '0',
			diDeliveryDateFrom : '0',
			diDeliveryDateTo : '0',
			diCreateDateFrom : '0',
			diCreateDateTo : '0',
			diStatusId : '0',
			diStatusName : '0',
			diCustomerId : '0',
			diCustomerCode : '0',
			partDestinationId : '0',
			partDestinationDestination : '0',
			destinationId : '0',
			destinationCode : '0',
			officeAddress : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}